import React, { useState } from 'react';
import { StyleSheet, ScrollView } from 'react-native';
import TripSearchWidget from '../TripSearchWidget/TripSearchWidget';
import { useDispatch } from 'react-redux';
import { setSearchInput, tripSearch } from '../../store/actions/search';
import { validateTripSearch } from '../../utils/search.utils';
import { openAlert } from '../../store/actions/alert';

const ResearchWidgetModal = ({ navigation }) => {
  const dispatch = useDispatch();
  const [searchTripLoading, setSearchTripLoading] = useState(false);
  const onSearchHandler = async (searchInput, searchInputState) => {
    setSearchTripLoading(true);
    const validationResult = validateTripSearch(searchInput);
    if (validationResult.isFailed) {
      dispatch(openAlert({ message: validationResult.msg }));
      setSearchTripLoading(false);
    } else {
      await dispatch(setSearchInput(searchInput, searchInputState));
      navigation.goBack();
      navigation.popToTop();
      dispatch(tripSearch());
    }
  };

  return (
    <ScrollView style={styles.widgetContainer}>
      <TripSearchWidget
        onSearch={onSearchHandler}
        loading={searchTripLoading}
        allowRehydration
      ></TripSearchWidget>
    </ScrollView>
  );
};

export const styles = StyleSheet.create({
  widgetContainer: {
    flexGrow: 1,
  },
});

export default ResearchWidgetModal;
